module.exports = __webpack_public_path__ + "static/media/tax_icon.596a3cbc.svg";